const MSG_SEND_TYPE = '/cosmos.bank.v1beta1.MsgSend';
function buildPath(eventField, address) {
    // Cosmos SDK >= 0.50 uses `query=<event>='<value>'` (the `events=` param
    // returns HTTP 500 "query cannot be empty" on Gonka's SDK 0.53 nodes).
    const query = `${eventField}='${address}'`;
    const params = new URLSearchParams({
        query,
        'pagination.limit': '50',
        order_by: 'ORDER_BY_DESC',
    });
    return `/cosmos/tx/v1beta1/txs?${params.toString()}`;
}
function parseItem(raw, address) {
    const messages = raw.tx?.body?.messages ?? [];
    const send = messages.find((m) => m['@type'] === MSG_SEND_TYPE);
    if (!send)
        return null;
    const fromAddress = send.from_address ?? '';
    const toAddress = send.to_address ?? '';
    const coin = send.amount?.[0];
    if (!coin)
        return null;
    const direction = fromAddress === address ? 'sent' : 'received';
    const counterparty = direction === 'sent' ? toAddress : fromAddress;
    const heightNum = Number.parseInt(raw.height, 10);
    const item = {
        hash: raw.txhash,
        direction,
        amount: coin.amount,
        denom: coin.denom,
        counterparty,
        timestamp: raw.timestamp,
        height: Number.isFinite(heightNum) ? heightNum : 0,
        memo: raw.tx?.body?.memo,
    };
    return item;
}
export function createHistoryReader(client, _boosterUrl) {
    async function fromRpc(address) {
        const [sentRes, recvRes] = await Promise.all([
            client.getApi(buildPath('message.sender', address)),
            client.getApi(buildPath('transfer.recipient', address)),
        ]);
        const all = [...sentRes.tx_responses, ...recvRes.tx_responses];
        const seen = new Set();
        const merged = [];
        for (const raw of all) {
            if (seen.has(raw.txhash))
                continue;
            seen.add(raw.txhash);
            const item = parseItem(raw, address);
            if (item)
                merged.push(item);
        }
        merged.sort((a, b) => b.height - a.height);
        return { items: merged, nextCursor: null, source: 'rpc' };
    }
    return {
        async get(address, _query) {
            return fromRpc(address);
        },
    };
}
//# sourceMappingURL=history.js.map